<div class="row" [formGroup]="editForm">
    <div class="col-12 m-b-25 d-flex flex-column">
        <div class="flex-center mb-4">
            <h5>Tất cả nhà đầu tư</h5>
            <input type="checkbox" class="checkbox ml-4" formControlName="isAllInvestor">
        </div>
        <div class="flex-center">
            <h5>Mail quảng cáo</h5>
            <input type="checkbox" class="checkbox ml-4" formControlName="isAdvertising">
        </div>
    </div>
    <div class="col-12 m-b-25 d-flex flex-column" [ngClass]="editForm.value.isAllInvestor && 'hidden'">
        <div class="flex-center">
            <h5>Lọc theo điều kiện</h5>
        </div>
        <div class="row" style="min-width: 500px;">
            <div class="col-12 m-b-25 row">
                <label class="col-3">Email</label>
                <div class="col-6 row">
                    <div class="col-12 row">
                        <div class="col-6">
                            <input class="form-control" formControlName="receiver">
                            <div class="d-flex">
                                <app-error-text [isDisplay]="isSaved && errors.email"
                                    [message]="'Có email cần được thêm vào.'">
                                </app-error-text>
                            </div>
                        </div>
                        <div class="col-6">
                            <button class="ant-btn ng-star-inserted ant-btn-primary" (click)="addEmail()">Add</button>
                            <button class="ant-btn ng-star-inserted ant-btn-default ml-3" (click)="cleanEmail()">Clean</button>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="summaryReceivers?.length">
                        <div class="d-flex flex-wrap tag-container">
                            <div class="tag-item" *ngFor="let tag of summaryReceivers; index as index">
                                <span>{{tag}}</span>
                                <span class="delete-icon" (click)="deleteTag(index)">x</span>
                            </div>
                        </div>
                        <div class="d-flex" *ngIf="summaryReceivers?.length < receivers.length">
                            <h3>Còn nữa ...</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 m-b-25 row">
                <label class="col-3">Sở hữu tài sản</label>
                <div class="col-2  flex-center">
                    <input class="form-control" type="radio" class="checkbox mr-4" formControlName="isHaveAsset"
                        name="isHaveAsset" value="null">
                    <span>Tất cả</span>
                </div>
                <div class="col-2  flex-center">
                    <input class="form-control" type="radio" class="checkbox mr-4" formControlName="isHaveAsset"
                        name="isHaveAsset" value="1">
                    <span>Có tài sản</span>
                </div>
                <div class="col-4  flex-center">
                    <input class="form-control" type="radio" class="checkbox mr-4" formControlName="isHaveAsset"
                        name="isHaveAsset" value="0">
                    <span>Không tài sản</span>
                </div>
            </div>
            <div class="col-12 m-b-25 row" *ngIf="editForm.value.isHaveAsset == '1'">
                <label class="col-3">Tổ chức phát hành</label>
                <div class="col-9">
                    <div style="max-width: 800px;">
                        <dropdown formControlName="issuer"  [list]="issuers" [key]="'userId'"
                            [title]="'Chọn tổ chức phát hành'" [isNoAll]="true"
                            [multiple]="true">
                        </dropdown>
                    </div>
                    
                </div>
            </div>
            <div class="col-12 m-b-25 row" *ngIf="editForm.value.isHaveAsset == '1'">
                <label class="col-3">Sản phẩm sở hữu</label>
                <div class="col-9">
                    <div style="max-width: 800px;">
                        <dropdown formControlName="product" [list]="products"
                            [title]="'Chọn sản phẩm sở hữu'"
                            [multiple]="true" [field]="'shortName'" [key]="'id'">
                        </dropdown>
                    </div>
                </div>
            </div>

            <div class="col-12 m-b-25 row" *ngIf="editForm.value.isHaveAsset == '1'">
                <label class="col-3">Top Asset Percent (%)</label>
                <div class="col-9">
                    <input class="form-control" formControlName="topAssetPercent"
                        [ngClass]="editForm.value.topBuyingPercent && 'disabled'">
                </div>
            </div>
            <div class="col-12 m-b-25 row" *ngIf="editForm.value.isHaveAsset == '1'">
                <label class="col-3">Top Buying Percent (%)</label>
                <div class="col-9">
                    <input class="form-control" formControlName="topBuyingPercent"
                        [ngClass]="editForm.value.topAssetPercent && 'disabled'">
                </div>
            </div>

            <div class="col-12 m-b-25 row" *ngIf="editForm.value.isHaveAsset == '0'">
                <label class="col-3">Đã bán hết</label>
                <div class="col-9">
                    <dropdown formControlName="typeCode" [list]="typeCodes"
                        [title]="'Chọn loại sản phẩm'" [key]="'code'">
                    </dropdown>
                </div>
            </div>

            <div class="col-12 m-b-25 row">
                <label class="col-3">Tỉnh</label>
                <div class="col-9">
                    <div style="max-width: 800px;">
                        <dropdown formControlName="province" [list]="provinces"
                            [title]="'Chọn Tỉnh'" [isNoAll]="true" [multiple]="true">
                        </dropdown>
                    </div>
                </div>
            </div>
            <div class="col-12 m-b-25 row">
                <label class="col-3">Tình trạng</label>
                <div class="col-9">
                    <dropdown formControlName="kycStatusCode" [list]="kycStatus" [key]="'code'"
                        [title]="'Chọn Tình trạng'">
                    </dropdown>
                </div>
            </div>
            <!-- <div class="col-12 m-b-25 row">
                <label class="col-3">Trạng thái</label>
                <div class="col-9">
                    <div style="max-width: 800px;">
                        <dropdown formControlName="status" [list]="statusList"
                            [title]="'Chọn Trạng thái'" [multiple]="true">
                        </dropdown>
                    </div>
                </div>
            </div> -->
            <div class="col-12 m-b-25 row">
                <label class="col-3">Đã tạo mục tiêu</label>
                <div class="col-2  flex-center">
                    <input class="form-control" type="radio" class="checkbox mr-4" formControlName="isCreatedGoal"
                        name="isCreatedGoal" value="null">
                    <span>Tất cả</span>
                </div>
                <div class="col-2  flex-center">
                    <input class="form-control" type="radio" class="checkbox mr-4" formControlName="isCreatedGoal"
                        name="isCreatedGoal" value="true">
                    <span>Có mục tiêu</span>
                </div>
                <div class="col-2  flex-center">
                    <input class="form-control" type="radio" class="checkbox mr-4" formControlName="isCreatedGoal"
                        name="isCreatedGoal" value="false">
                    <span>Không có mục tiêu</span>
                </div>

            </div>
            <div class="col-12 m-b-25 row">
                <label class="col-3">Giới tính</label>
                <div class="col-2  flex-center">
                    <input class="form-control" type="radio" class="checkbox mr-4" formControlName="gender"
                        name="gender" value="null">
                    <span>Tất cả</span>
                </div>
                <div class="col-2  flex-center">
                    <input class="form-control" type="radio" class="checkbox mr-4" formControlName="gender"
                        name="gender" value="1">
                    <span>Nam</span>
                </div>
                <div class="col-2  flex-center">
                    <input class="form-control" type="radio" class="checkbox mr-4" formControlName="gender"
                        name="gender" value="0">
                    <span>Nữ</span>
                </div>
            </div>
            <div class="col-12 m-b-25 row" (mousedown)="changeSlider()" (mouseup)="changeSlider()">
                <label class="col-3">Độ tuổi</label>
                <div class="col-6 row">
                    <nz-slider style="width: 400px;" nzRange [nzMin]="18" [nzMax]="100" 
                        [(ngModel)]="valueAge" [ngModelOptions]="{standalone: true}">
                    </nz-slider>
                </div>
            </div>
            <div class="col-12 m-b-25 row">
                <label class="col-3">Ngày active Investor</label>
                <div class="col-9">
                    <filter-start-end-date id="filterStartEndDate" [isDefaultData]="false"
                        #filterStartEndDate [startDate]="editForm.value.activeStart" [endDate]="editForm.value.activeEnd">
                    </filter-start-end-date>
                </div>
            </div>

        </div>
    </div>
    <div class="col-12 m-b-25 d-flex flex-column">
        <div class="d-flex">
            <h5>Hẹn giờ</h5>
        </div>
        <div class="row" style="min-width: 500px;">
            <div class="col-12 m-b-25 row">
                <label class="col-3">Thời gian bắt đầu</label>
                <div class="col-9">
                    <input-datepicker-and-time [(data)]="scheduledTime"></input-datepicker-and-time>
                </div>
            </div>
        </div>
    </div>
</div>